import { useContext } from 'react';
import { updateProfile } from '@/modules/profile/profile-api';
import { AppContext } from '@/store/context';
/**
 * Состояние «подсказка пройдена» для одного tutorial-ключа.
 *
 * Источник истины — синхронизируемый профиль (state.profile.seenTutorials).
 * localStorage используется как офлайн-safe дубль и обратная совместимость.
 * Вне AppContext (Storybook) — только localStorage, поведение как раньше.
 */
export function useTutorialSeen(storageKey) {
    const ctx = useContext(AppContext);
    const inProfile = ctx?.state.profile.seenTutorials?.includes(storageKey) ?? false;
    const inLocal = !!localStorage.getItem(storageKey);
    const seen = inProfile || inLocal;
    const markSeen = () => {
        localStorage.setItem(storageKey, '1'); // мгновенно + офлайн
        if (!ctx)
            return;
        const current = ctx.state.profile.seenTutorials ?? [];
        if (current.includes(storageKey))
            return;
        const next = [...current, storageKey];
        ctx.dispatch({ type: 'UPDATE_PROFILE', updates: { seenTutorials: next } });
        // best-effort — офлайн не должен ломать отметку «пройдено»
        updateProfile({ seenTutorials: next }).catch(() => { });
    };
    return { seen, markSeen };
}
